/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
// BASE Components
import BASELoading from "../../../../../../../@BASE/core/BASELoading";
// Material UI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
// Custom Components
import ComponentCard from "../components/Component";
import ComponentPreview from "../components/Preview";
import ComponentStepLabel from "../components/StepLabel";
import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";
import VideoDiagram from "../components/cards/video/Video";
import SubComponentCard from "../components/SubComponent";

const IntroductionVideo = (props) => {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
        noInstructions
      />

      <Typography className="text-18 font-bold p-16 pb-0">Video:</Typography>

      <ComponentCard
        title="Video"
        id="video"
        commentsCount={componentCommentsCount("video")}
      >
        {/* <ComponentPreview>
          <VideoDiagram />
        </ComponentPreview> */}
        {data.description && (
          <>
            <ComponentStepLabel number="1" title="Description:" />
            <Paper elevation={0} variant="outlined" square className="p-16 m-16">
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography className="text-14 m-0">
                    {data.description}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </>
        )}

        {data.transcript && (
          <>
            <ComponentStepLabel number="2" title="Transcript:" />
            <Paper elevation={0} variant="outlined" square className="p-16 m-16">
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography className={`${tl} m-0 whitespace-pre-wrap`} dir={dir}>
                    {data.transcript}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </>
        )}

        <ComponentStepLabel number="3" title="Segment(s):" />
        {data.core &&
          data.core.map((segment, index) => (
            <SubComponentCard
              key={segment.id}
              title={"Segment " + (index + 1)}
              id={segment.id}
              commentsCount={componentCommentsCount(segment.id)}
            >
              <Paper elevation={0} square className="p-16">
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Video Segment Description:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography className="text-14 m-0 whitespace-pre-wrap">
                      {segment.description}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Narration:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography
                      className={`${tl} m-0 whitespace-pre-wrap`}
                      dir={dir}
                    >
                      {segment.text_tl}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Segment Time
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography className="text-14 m-0 whitespace-pre-wrap">
                      {segment.start_minute}:
                      {segment.start_second < 10 ? `0${segment.start_second}` : segment.start_second} -
                      {segment.end_minute}:
                      {segment.end_second < 10 ? `0${segment.end_second}`: segment.end_second}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </SubComponentCard>
          ))}
      </ComponentCard>
    </div>
  );
};

export default IntroductionVideo;
